import { TextField } from '@/components/ui/TextField';
import { Toggle } from '@/components/ui/Toggle';
import { SettingsCard } from './fields';
import type { SettingsSectionProps } from './fields';

export function NotificationsSection({ settings, onChange }: SettingsSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <SettingsCard
        title="Customer notifications"
        description="Channels used to keep customers updated on their return."
      >
        <Toggle
          label="Email"
          checked={settings.customerEmailEnabled}
          onChange={(checked) => onChange({ customerEmailEnabled: checked })}
        />
        <Toggle
          label="SMS"
          checked={settings.customerSmsEnabled}
          onChange={(checked) => onChange({ customerSmsEnabled: checked })}
        />
        <Toggle
          label="WhatsApp"
          checked={Boolean(settings.customerWhatsappEnabled)}
          onChange={(checked) => onChange({ customerWhatsappEnabled: checked })}
        />
      </SettingsCard>

      <SettingsCard title="Internal notifications">
        <TextField
          label="Notify email"
          requiredMark
          type="email"
          hint="Where new-return alerts are sent."
          value={settings.merchantNotifyEmail}
          onChange={(event) => onChange({ merchantNotifyEmail: event.target.value })}
        />
      </SettingsCard>
    </div>
  );
}
